import DevicePageTemplate from "./DevicePageTemplate";
import {gql} from "@apollo/client";
import {useTranslation} from "react-i18next";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const PAGINATE_AKIFERRA = gql`
    query PaginateDeviceAkiferra($pagination: Pagination!, $sortBy: [SortBy!], $criteria: DeviceAkiferraCriteria) {
        paginateDeviceAkiferra(pagination: $pagination, sortBy: $sortBy, criteria: $criteria) {
            pageInfo { totalElements totalPages numberOfElements pageNumber pageSize }
            content {
                id serialNumber installationDate
                location {
                    id name address { fullAddress latitude longitude }
                    customer { id name reseller { id name } }
                }
                updatedTimestamp deleted
            }
        }
    }
`;
const CREATE_DEVICE_AKIFERRA = gql`
    mutation CreateDeviceAkiferra($input: DeviceAkiferraInput!) {
        createDeviceAkiferra(input: $input) {
            id serialNumber installationDate updatedTimestamp deleted
        }
    }
`;
const UPDATE_DEVICE_AKIFERRA = gql`
    mutation UpdateDeviceAkiferra($id: ID!, $input: DeviceAkiferraInput!) {
        updateDeviceAkiferra(id: $id, input: $input) {
            id serialNumber installationDate updatedTimestamp deleted
        }
    }
`;
const DELETE_DEVICE_AKIFERRA = gql`
    mutation DeleteDeviceAkiferra($id: ID!) {
        deleteDeviceAkiferra(id: $id)
    }
`;

const queries = {
    PAGINATE: PAGINATE_AKIFERRA,
    CREATE: CREATE_DEVICE_AKIFERRA,
    UPDATE: UPDATE_DEVICE_AKIFERRA,
    DELETE: DELETE_DEVICE_AKIFERRA,
};

export default function Akiferra() {
    const {t} = useTranslation();
    return <DevicePageTemplate title="Akiferra" subtitle={t("akiferra.subtitle")} queries={queries} icon={<FilterAltIcon/>}/>;
}
